import React, { useEffect, useState } from "react";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import { CounsellorBookingDetails, SubmitReview } from "../api/api";
import { environment } from "../../environments/environments";
import { FaStar, FaClock } from "react-icons/fa";
import "../../Component/BookingDetails/BookingDetails.css";
import Swal from "sweetalert2";

const BookingDetails = () => {
  //   const { id, status, counsellor_id } = useParams();
  const { id } = useParams();
  const location = useLocation();
  const { status, counsellor_id } = location.state || {};
  const [bookingDetails, setBookingDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  console.log("stausllll", status);
  useEffect(() => {
    const getBookingDetail = async () => {
      try {
        const response = await CounsellorBookingDetails({ booking_id: id });
        setBookingDetails(response?.data);

        const userData = JSON.parse(localStorage.getItem("currentUser"));
        const userId = userData?.id || userData?._id;

        const existingRating = response?.ratings?.find(
          (r) => r?.user_id === userId
        );
        if (existingRating) {
          setRating(existingRating.rating);
          setReview(existingRating.review);
        }
      } catch (error) {
        console.error("Error fetching booking details:", error);
      } finally {
        setLoading(false);
      }
    };

    getBookingDetail();
  }, [id]);

  const handleSubmitRating = async () => {
    if (rating === 0) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "Please select a rating before submitting.",
      });
      return;
    }

    const userData = JSON.parse(localStorage.getItem("currentUser"));
    const userId = userData?.id || userData?._id;

    try {
      const values = {
        rating,
        review,
        user_id: userId,
        counsellor_id,
      };
      console.log("valuess_for_rating", values);
      const res = await SubmitReview(values);
      Swal.fire({
        icon: "success",
        title: "Thank you!",
        text: res?.message || "Your review has been submitted.",
        confirmButtonText: "OK",
      }).then((result) => {
        // Go back when the "OK" button is clicked
        if (result.isConfirmed) {
          window.history.back();
        }
      });
    } catch (err) {
      console.error("Submission error", err);
      Swal.fire({
        icon: "error",
        title: "Something went wrong!",
        text: "Unable to submit review. Please try again later.",
        confirmButtonText: "OK",
      }).then((result) => {
        // Go back when the "OK" button is clicked
        if (result.isConfirmed) {
          window.history.back();
        }
      });
    }
  };

  if (loading) {
    return <div className="loader"></div>;
  }

  if (!bookingDetails) {
    return <div className="error">Unable to load booking details.</div>;
  }

  const { booking_id, counsellor, user, date, time, created_at } =
    bookingDetails;
  const counsellorImage = `${environment.url}/uploads/counsellors/${counsellor?.image}`;

  return (
    <div className="bookingcontainer">
      <div className="bookingcard">
        <img src={counsellorImage} alt="Counsellor" className="bookingavatar" />
        <div>
          <div className="bookinglabel">Counsellor</div>
          <div className="bookingvalue">{counsellor?.name}</div>
        </div>
      </div>

      <div className="bookinginfo">
        <Detail label="Booking ID" value={booking_id} />
        <Detail label="User" value={user?.name} />
        <Detail
          label="Session On"
          value={`${moment(date).format("DD MMMM YYYY")} at ${time}`}
        />
        <Detail
          label="Status"
          value={status === "1" ? "Booked" : "Completed"}
          valueClass={status === "1" ? "green" : "red"}
        />
        <Detail
          label="Booked On"
          value={moment(created_at).format("D MMM YYYY, h:mm A")}
        />
      </div>

      <hr className="bookingdivider" />

      {status === "0" ? (
        <div className="bookingrating-section">
          <h2 className="bookingrating-title">Rate This Sessions</h2>
          <div className="bookingstars">
            {[1, 2, 3, 4, 5].map((num) => (
              <button
                key={num}
                // onClick={() => setRating(num)}
                onClick={() => {
                  if (num === rating) {
                    setRating(rating - 1);
                  } else {
                    setRating(num);
                  }
                }}
                className="bookingstar-btn"
              >
                {/* <FaStar className={num <= rating ? "star active" : "star"} /> */}
                <FaStar
                  className={`bookingstar ${num <= rating ? "active" : ""}`}
                />
              </button>
            ))}
          </div>

          <label className="bookingreview-label">
            Write a Review (Optional)
          </label>
          <textarea
            className="bookingreview-input"
            rows={4}
            placeholder="Share your experience..."
            value={review}
            onChange={(e) => setReview(e.target.value)}
          ></textarea>

          <button onClick={handleSubmitRating} className="bookingsubmit-btn">
            Submit
          </button>
        </div>
      ) : (
        <div className="bookingrating-section">
          <h2 className="bookingrating-title">Rate This Session</h2>
          <div className="bookingclock-message">
            <FaClock className="bookingclock-icon" />
            <p className="booking-rating-tile">
              You can rate once this session is over
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

const Detail = ({ label, value, valueClass = "" }) => (
  <div className="bookingdetail-row">
    <div className="bookinglabel">{label}</div>
    <div className={`bookingvalue ${valueClass}`}>{value}</div>
  </div>
);

export default BookingDetails;
